// Auto-generated by scripts/version.js — do not edit
export const APP_VERSION   = '0.2.3';
export const BUILD_DATE    = '2026-09-20T15:03:49.465Z';
export const GIT_HASH      = 'cfc1855';
export const VERSION_LABEL = 'v0.2.3 (cfc1855 · 2026-09-20 15:03)';
